import type { Todo } from "../../domain/entities.ts";

export interface TaskPanelState {
  selectedId: string | null;
  editing: boolean;
  draft: Todo | null;
}

export function createTaskPanelState(): TaskPanelState {
  return { selectedId: null, editing: false, draft: null };
}
